import React from 'react'
import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import { encrypt } from 'utils/rsa'
import keyMirror from 'pkeymirror'
import { Toast, Modal, WhiteSpace } from 'antd-mobile'
import { Button } from 'components'
import { getAppSalt } from 'store/siteConfig'
import { getUUID, intl } from 'utils'
import messages from './messages'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const BANK_CARD_ADD_BANK_CARD = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  ADVANCE_REQUEST: null,
  ADVANCE_SUCCESS: null,
}, 'BANK_CARD_ADD_BANK_CARD')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  Toast.loading('', 0)
  return (dispatch, getState) => {
    const saltKey = getUUID()
    dispatch(getAppSalt(saltKey)).then((res) => {
      const { salt } = res.payload
      const { agreements, cvv, cardNo, ...restData } = data
      restData.cvv = encrypt(cvv, salt)
      restData.cardNo = encrypt(cardNo.replace(/ /g, ''), salt)
      dispatch(
        callAPI({
          dispatch: dispatch,
          method: 'POST',
          header: {
            'Salt-Key': saltKey,
          },
          body: restData,
          endpoint: 'cgs/personal/card/payment/bind',
          requestAction: BANK_CARD_ADD_BANK_CARD.INIT_REQUEST,
          successAction: BANK_CARD_ADD_BANK_CARD.INIT_SUCCESS,
          success: function(result) {
            dispatch(advance({ cardId: result.cardId }))
          },
        })
      )
    })
  }
}

var alertInstance
export function advance(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          ...data,
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          userAgent: navigator.userAgent,
        },
        endpoint: 'cgs/personal/card/advance',
        requestAction: BANK_CARD_ADD_BANK_CARD.ADVANCE_REQUEST,
        successAction: BANK_CARD_ADD_BANK_CARD.ADVANCE_SUCCESS,
        success: function(result) {
          if (!result.payUrl) {
            dispatch(getAppSalt(getUUID()))
            return Toast.info(
              'Bank validate url get failed, please try again later!'
            )
          }
          Toast.hide()
          alertInstance = Modal.alert(
            '',
            <div className='text-center' style={{ position: 'relative' }}>
              <span
                className='iconfont iconState-Wait'
                style={{ fontSize: '40px' }}
              />
              <WhiteSpace size='xs' />
              <p className='font-sm'>
                <b>{intl.formatMessage(messages.processing)}</b>
              </p>
              <p
                className='font-xs gray'
                dangerouslySetInnerHTML={{
                  __html: intl.formatHTMLMessage(messages.description),
                }}
              />
              <WhiteSpace size='lg' />
              <Button
                type='primary'
                name='custom'
                inline
                className='am-button-xs'
                onClick={() => {
                  if (_.startsWith(result.payUrl, 'http')) {
                    window.location.href = result.payUrl
                    return
                  }
                  document.open()
                  document.write(result.payUrl)
                  document.close()
                }}
              >
                {intl.formatMessage(messages.ok)}
              </Button>
            </div>,
            []
          )
        }
      })
    )
  }
}

export function closeModal() {
  return (dispatch) => {
    alertInstance && alertInstance.close()
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BANK_CARD_ADD_BANK_CARD.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_ADD_BANK_CARD.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_ADD_BANK_CARD.ADVANCE_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_ADD_BANK_CARD.ADVANCE_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'bankCardAddBankCard',
    reducerMap: {
      bankCardAddBankCardState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
